import { render, staticRenderFns } from "./TrPageCorner.vue?vue&type=template&id=28ff126c&"
import script from "./TrPageCorner.vue?vue&type=script&lang=js&"
export * from "./TrPageCorner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports